import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import Loadable from "react-loadable";
import styled from "styled-components";

import { getCookie, detectBrowser } from "lib/helpers/loginHelpers.js";

import Login from "layout/Login";
import projectList from "config/projectList.js";

import { SetupLoader } from "loaders";

const Base = styled.div`
	position: relative;
	overflow: hidden;
	min-height: 100vh;
`;

class LoginController extends React.Component {

	constructor(props) {
		super(props);
		this.defaultDarkTheme = this.defaultDarkTheme.bind(this);
	}

	componentDidMount() {
		this.props.checkForCurrentSession();
		this.props.checkTermsAndConditionsAccepted();
		// Browser detection
		this.props.setBrowserType(detectBrowser());
		document.body.classList.add(this.props.darkUI ? "darkUI" : "lightUI");
	}

	componentDidUpdate(prevProps) {
		this.props.checkTermsAndConditionsAccepted();
		if (prevProps.darkUI !== this.props.darkUI) {
			document.body.classList.remove("lightUI");
			document.body.classList.remove("darkUI");
			document.body.classList.add(this.props.darkUI ? "darkUI" : "lightUI");
		}
	}

	defaultDarkTheme() {
		// TODO: Set this based on the URL (outside of project scope)
		return false;
	}


	render() {
		const { props, state } = this;
		const darkTheme = _.isString(props.darkUI) ? this.defaultDarkTheme() : props.darkUI;

		if (!props.loggedIn) {
			this.props.apolloClient.clearStore();
		}

		return (
			<Base
				className={`${props.currentProject || ""} ${
					props.currentProject === "sevenTwenty_uscc" ||
					props.currentProject === "bcbs" ||
					props.currentProject === "midterms" ||
					props.currentProject === "dccc"
						? "sevenTwenty"
						: ""
				} ${darkTheme ? "darkUI" : "lightUI"}`}
			>
				{props.checkedForExistingUserOnLoad &&
					(!props.loggedIn || !props.termsAndConditionsAccepted ? (
						<Login darkUI={darkTheme} />
					) : (
						<SetupLoader currentProject={props.currentProject} />
					))}
			</Base>
		);
	}
}

LoginController.propTypes = {
	checkedForExistingUserOnLoad: PropTypes.bool.isRequired,
	checkForCurrentSession: PropTypes.func.isRequired,
	checkTermsAndConditionsAccepted: PropTypes.func.isRequired,
	apolloClient: PropTypes.object.isRequired,
	darkUI: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
	loggedIn: PropTypes.bool.isRequired,
	currentProject: PropTypes.string, // initially ""
	setBrowserType: PropTypes.func.isRequired,
	termsAndConditionsAccepted: PropTypes.bool.isRequired,
	userName: PropTypes.string.isRequired,
};

export default LoginController;
